import fetch from './fetch'
import { Base64 } from 'js-base64'
export const accessKey = '8b6f45eedc654ffdbff765c9a9eb02c2'

class VisitorsApi {
	public getUserInfo() {
		return fetch({
			url: 'injury/user/getUserInfo',
		})
	}

	public modifiedPwd(form: any) {
		form.oldPwd = Base64.encode(form.oldPwd)
		form.newPwd = Base64.encode(form.newPwd)
		return fetch({
			url: 'injury/user/modifiedPwd',
			method: 'POST',
			data: form,
		})
	}

	public getCompanies(companyId = '') {
		return fetch({
			url: 'injury/resource/partner',
			params: {
				companyId,
			},
		})
	}

	public getUserList(form: object) {
		return fetch({
			url: 'injury/user/searchEmployeeList',
			method: 'post',
			data: form,
		})
	}

	public updateVisitor(form: object) {
		return fetch({
			url: 'injury/visitor/update',
			method: 'post',
			data: form,
		})
	}

	public changeVisitorStatus(form: object) {
		return fetch({
			url: 'injury/visitor/changeStatus',
			method: 'post',
			data: form,
		})
	}

	public activeVisitor(form: object) {
		return fetch({
			url: 'injury/visitor/active',
			method: 'post',
			data: form,
		})
	}

	public inactiveVisitor(form: object) {
		return fetch({
			url: 'injury/visitor/inactive',
			method: 'post',
			data: form,
		})
	}

	public activeOperation(form: object) {
		return fetch({
			url: '/injury/visitor/activeExam',
			method: 'post',
			data: form,
		})
	}

	public inactiveOperation(form: object) {
		return fetch({
			url: '/injury/visitor/inactiveExam',
			method: 'post',
			data: form,
		})
	}

	public addVisitor(form: any) {
		return fetch({
			url: 'injury/visitor/add',
			method: 'POST',
			data: form,
		})
	}

	/* below this note edit by ltc */
	public getVisitorList(form: object) {
		return fetch({
			url: 'injury/visitor/queryList',
			method: 'post',
			data: form,
		})
	}

	public getVisitorOrders(form: object) {
		return fetch({
			url: 'injury/visitor/visitorOrders',
			method: 'post',
			data: form,
		})
	}

	public getVisitorEvaluateInfo(visitorPhone = '') {
		return fetch({
			url: 'injury/visitor/evaluateInfo',
			method: 'post',
			params: {
				visitorPhone,
			},
		})
	}

	public exportList() {
		return fetch({
			url: 'injury/static/import_visitor.xlsx',
			method: 'post',
			params: {},
			timeout: 0,
			responseType: 'blob',
		})
	}

	public exportVisitor(form: any) {
		return fetch({
			url: 'injury/visitor/export',
			method: 'post',
			data: form,
			timeout: 0,
			responseType: 'blob',
		})
	}

	public uploadImage(options: any) {
		const { formData } = options
		return fetch({
			url: `media/upload/${accessKey}`,
			method: 'POST',
			timeout: 0, // 无超时时间
			data: formData,
			headers: {
				originType: 'PC',
			},
		})
	}

	public recognizeIdCard(options: any) {
		const { formData } = options
		return fetch({
			url: `media/ocr/recognizeIdCard/${accessKey}`,
			method: 'POST',
			timeout: 0, // 无超时时间
			data: formData,
			headers: {
				originType: 'PC',
			},
		})
	}

	public uploadFile(options: any) {
		const { formData } = options
		return fetch({
			url: `media/file/upload/${accessKey}`,
			method: 'POST',
			timeout: 0, // 无超时时间
			data: formData,
			headers: {
				originType: 'PC',
			},
		})
	}

	public operateAndUpload(options: any) {
		const { formData, params } = options
		return fetch({
			url: `media/operateAndUpload/${accessKey}`,
			method: 'POST',
			timeout: 0, // 无超时时间
			data: formData,
			params,
		})
	}

	public getPic(picId: any) {
		return fetch({
			url: `injury/visitor/getPic`,
			params: {
				picId,
			},
		})
	}

	public getVisitorAnalysis(visitorPhone: any) {
		return fetch({
			url: `injury/visitor/analysis`,
			params: {
				visitorPhone,
			},
		})
	}

	public hasVisitorInArea(form: any) {
		return fetch({
			url: `injury/visitor/checkHasVisitorInArea`,
			method: 'GET',
			params: form,
		})
	}

	public getCommentList(form: any) {
		return fetch({
			url: `/injury/visitor/evaluateList`,
			method: 'POST',
			data: form,
		})
	}

	public getVisitorWorkInfo(visitorId: string) {
		return fetch({
			url: `/injury/visitor/workInfo`,
			method: 'POST',
			params: {
				visitorId,
			},
		})
	}

	public deleteDevice(form: any) {
		return fetch({
			url: `/injury/visitor/device/delete`,
			method: 'POST',
			data: form,
		})
	}
	public getVisitorInfo(form: any) {
		return fetch({
			url: `/injury/visitor/visitorInfo`,
			method: 'GET',
			params: form,
		})
	}
	public unLocked(form: any) {
		return fetch({
			url: `/injury/visitor/unLocked`,
			method: 'POST',
			data: form,
		})
	}
	public locked(form: any) {
		return fetch({
			url: `/injury/visitor/locked`,
			method: 'POST',
			data: form,
		})
	}
	public logList(form: any) {
		return fetch({
			url: `/injury/visitor/logList`,
			method: 'POST',
			data: form,
		})
	}
	public orderBaseInfo(orderId: any) {
		return fetch({
			url: `/injury/message/board/orderBaseInfo`,
			method: 'POST',
			params: {
				orderId,
			},
		})
	}
}
export default new VisitorsApi()
